module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasService),
      expression: "hasService"
    }],
    staticClass: "change-service",
    on: {
      "click": function($event) {
        _vm.changeService(_vm.leg)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('serviceSelect.changeSelect')))])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-608c26de", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-608c26de","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ServiceSelection/ChangeService.vue
// module id = 2101
// module chunks = 0